export default __webpack_public_path__ + "img/467ac47e.gif";